import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import Button from '../../../../shared/_TBComponents/Button';
import { setIsLegendInfoModalShowing } from '../../ducks/sportCoachDashboardActions';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import LegendSVG from '../../../../shared/images/sc-dash-metrics-legend.png';

const DescriptionImage = styled('div')`
  background-image: url(${LegendSVG});
  background-repeat: no-repeat;
  height: 275px;
  width: 685px;
`;

const Header = styled('div')`
  color: #9E9E9E;
  font-size: 16px;
`;

const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const ModalContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: ${BoxShadow};
  font-family: 'Nunito Sans';
  left: 50%;
  margin: -125px 0px 0px -345px;
  padding: 24px;
  position: absolute;
  top: 50%;
  width: 715px;
  z-index: 1003;
`;

const ModalOverlay = styled('div')`
  background-color: rgba(216, 216, 216, 0.8);
  height: 100vh;
  opacity: ${(props) => (props.isActive ? 0.5 : 0)};
  pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};
  position: absolute;
  transition: opacity 0.3s ease;
  width: 100vw;
  z-index: 1002;
`;

const Title = styled('div')`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const SCLegendInfoModal = () => {
  const { isLegendInfoModalShowing } = useSelector(
    (state) => state.sportCoachDashboard.ui,
  );

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setIsLegendInfoModalShowing(false));
  };

  if (!isLegendInfoModalShowing) return null;

  return (
    <>
      <ModalContainer>
        <HeaderContainer>
          <Header>Legend</Header>
          <Button
            aria-label='Close modal'
            icon='remove'
            iconColor='#9E9E9E'
            iconOnly
            noBorder
            onClick={handleClose}
          />
        </HeaderContainer>
        <Title>Key Performance Exercises</Title>
        <DescriptionImage />
      </ModalContainer>
      <ModalOverlay
        isActive={isLegendInfoModalShowing}
        onClick={handleClose}
      />
    </>
  );
};

export default SCLegendInfoModal;
